import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import en from "./en";
import ar from "./ar";

// Initialize i18next
i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind i18next to React
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: "en", // Fallback language
    interpolation: {
      escapeValue: false, // React handles escaping by default
    },
    debug: process.env.NODE_ENV === "development", // Enable debug mode in development
  });

export default i18n;
